const qs = require('query-string')

function getDefaultState() {
  return {
    reports: {}
  }
}
import axios from 'axios'
export default {
  namespaced: true,
  state: {
    reports: {
      salesByPeriod: undefined,
      salesByBrands: undefined,
      salesByPlatforms: undefined,
      salesByHours: undefined,
      funnelsByPeriod: undefined,
      repeatersByPeriod: undefined,
      prepTimeByPeriod: undefined,
      reviews: undefined,
      reviewDetails: undefined,
      addresses: undefined,
      items: undefined
    }
  },
  getters: {
    reports(state) {
      return state.reports
    }
  },
  mutations: {
    setReports(state, data) {
      state.reports = { ...state.reports, ...data }
    },
    setSalesByBrands(state, data) {
      state.reports.salesByBrands = { ...state.reports.salesByBrands, ...data }
    },
    setSalesByPeriod(state, data) {
      state.reports.salesByPeriod = { ...state.reports.salesByPeriod, ...data }
    },
    setSalesByPlatforms(state, data) {
      state.reports.salesByPlatforms = {
        ...state.reports.salesByPlatforms,
        ...data
      }
    },
    setSalesByHours(state, data) {
      state.reports.salesByHours = { ...state.reports.salesByHours, ...data }
    },
    setFunnelsByPeriod(state, data) {
      state.reports.funnelsByPeriod = {
        ...state.reports.funnelsByPeriod,
        ...data
      }
    },
    setRepeatersByPeriod(state, data) {
      state.reports.repeatersByPeriod = {
        ...state.reports.repeatersByPeriod,
        ...data
      }
    },
    setPrepTimeByPeriod(state, data) {
      state.reports.prepTimeByPeriod = {
        ...state.reports.prepTimeByPeriod,
        ...data
      }
    },
    setReviews(state, data) {
      state.reports.reviews = { ...state.reports.reviews, ...data }
    },
    setReviewDetails(state, data) {
      state.reports.reviewDetails = { ...state.reports.reviewDetails, ...data }
    },
    setAddresses(state, data) {
      state.reports.addresses = { ...state.reports.addresses, ...data }
    },
    setItems(state, data) {
      state.reports.items = { ...state.reports.items, ...data }
    },
    clearState(state) {
      Object.assign(state, getDefaultState())
    }
  },
  actions: {
    async getReports({ commit }) {
      await axios
        .get('/reports')
        .then(({ data }) => {
          commit('setReports', data)
        })
        .catch((error) => {
          console.log('catch : error :' + error)
        })
    },
    async getSalesByPeriod({ commit }, query) {
      await axios
        .get('/reports/salesByPeriod' + `?${qs.stringify(query)}`)
        .then(({ data }) => {
          commit('setSalesByPeriod', data)
        })
        .catch((error) => {
          console.log('catch : error :' + error)
        })
    },
    async getSalesByBrands({ commit }, query) {
      await axios
        .get('/reports/salesByBrands' + `?${qs.stringify(query)}`)
        .then(({ data }) => {
          commit('setSalesByBrands', data)
        })
        .catch((error) => {
          console.log('catch : error :' + error)
        })
    },
    async getSalesByPlatforms({ commit }, query) {
      await axios
        .get('/reports/salesByPlatforms' + `?${qs.stringify(query)}`)
        .then(({ data }) => {
          commit('setSalesByPlatforms', data)
        })
        .catch((error) => {
          console.log('catch : error :' + error)
        })
    },
    async getSalesByHours({ commit }, query) {
      await axios
        .get('/reports/salesByHours' + `?${qs.stringify(query)}`)
        .then(({ data }) => {
          commit('setSalesByHours', data)
        })
        .catch((error) => {
          console.log('catch : error :' + error)
        })
    },
    async getFunnelsByPeriod({ commit }, query) {
      await axios
        .get('/reports/funnelsByPeriod' + `?${qs.stringify(query)}`)
        .then(({ data }) => {
          commit('setFunnelsByPeriod', data)
        })
        .catch((error) => {
          console.log('catch : error :' + error)
        })
    },
    async getRepeatersByPeriod({ commit }, query) {
      await axios
        .get('/reports/repeatersByPeriod' + `?${qs.stringify(query)}`)
        .then(({ data }) => {
          commit('setRepeatersByPeriod', data)
        })
        .catch((error) => {
          console.log('catch : error :' + error)
        })
    },
    async getPrepTimeByPeriod({ commit }, query) {
      await axios
        .get('/reports/prepTimeByPeriod' + `?${qs.stringify(query)}`)
        .then(({ data }) => {
          commit('setPrepTimeByPeriod', data)
        })
        .catch((error) => {
          console.log('catch : error :' + error)
        })
    },
    async getReviews({ commit }, query) {
      await axios
        .get('/reports/reviews' + `?${qs.stringify(query)}`)
        .then(({ data }) => {
          commit('setReviews', data)
        })
        .catch((error) => {
          console.log('catch : error :' + error)
        })
    },
    async getReviewDetails({ commit }, query) {
      await axios
        .get('/reports/reviewDetails' + `?${qs.stringify(query)}`)
        .then(({ data }) => {
          commit('setReviewDetails', data)
        })
        .catch((error) => {
          console.log('catch : error :' + error)
        })
    },
    async getAddresses({ commit }, query) {
      await axios
        .get('/reports/addresses' + `?${qs.stringify(query)}`)
        .then(({ data }) => {
          commit('setAddresses', data)
        })
        .catch((error) => {
          console.log('catch : error :' + error)
        })
    },
    async getItems({ commit }, query) {
      await axios
        .get('/reports/items' + `?${qs.stringify(query)}`)
        .then(({ data }) => {
          commit('setItems', data)
        })
        .catch((error) => {
          console.log('catch : error :' + error)
        })
    }
  }
}
